import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { retrieveFreightOfferByIdApi } from "../../../../components/api/FreightOfferApiService";

const FreightOfferButton = ({ row, id, setEditFreightOffer }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return; 
    setLoading(true);
    try {
      const freightOfferData = await retrieveFreightOfferByIdApi(id);
      if (!freightOfferData) {
        alert("No data returned from the API.");
        return;
      }
      setEditFreightOffer({
        visible: true,
        data: freightOfferData?.data,
        index: row?.index,
      });
      console.log(freightOfferData);
    } catch (error) {
      console.error("Error retrieving freightOffer:", error);
    } finally {
      setLoading(false); 
    }
  };

  return (
    <Button
      sx={{
        minWidth: 0,
        padding: "2px 4px",
        fontSize: "0.8rem",
        lineHeight: 1,
      }}
      onClick={handleClick}
      variant="text"
      disabled={loading}
      startIcon={loading && <CircularProgress size={16} />}
    >
      {id}
    </Button>
  );
};

export default FreightOfferButton;
